import { gql } from '@apollo/client';

export const GET_WITHDRAWALS = gql`
  query GET_WITHDRAWALS(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: [ApplicationStatus!]
  ) {
    withdrawals(ids: $ids, projectIds: $projectIds, status: $status) {
      id
      date
      progressReport {
        id
        filename
      }
      justification
      status
    }
  }
`;

export const GET_WITHDRAWAL = gql`
  query GET_WITHDRAWAL(
    $ids: [ID!]
    $projectIds: [ID!]
    $status: [ApplicationStatus!]
  ) {
    withdrawals(ids: $ids, projectIds: $projectIds, status: $status) {
      id
      date
      progressReport {
        id
        filename
      }
      justification
      status
      approvalRoute {
        sequence
        appointedApprover {
          role {
            id
            name
          }
          faculty {
            id
            name
          }
          department {
            id
            name
          }
        }
        approvalSteps {
          sequence
          name
          approverListingType
          appointedApprover {
            role {
              id
              name
            }
            faculty {
              id
              name
            }
            department {
              id
              name
            }
          }
          approver {
            id
            netId
            name
          }
          approved
          comment
          date
        }
      }
    }
  }
`;

export const ADD_WITHDRAWAL = gql`
  mutation ADD_WITHDRAWAL($input: AddWithdrawalInput!) {
    addWithdrawal(input: $input) {
      id
    }
  }
`;

export const UPDATE_WITHDRAWAL = gql`
  mutation UPDATE_WITHDRAWAL($input: UpdateWithdrawalInput!) {
    updateWithdrawal(input: $input) {
      id
    }
  }
`;

export const SUBMIT_WITHDRAWAL = gql`
  mutation SUBMIT_WITHDRAWAL($input: SubmitWithdrawalInput!) {
    submitWithdrawal(input: $input) {
      id
    }
  }
`;

export const SUBMIT_WITHDRAWAL_WITH_CUSTOM_DATE = gql`
  mutation SUBMIT_WITHDRAWAL_WITH_CUSTOM_DATE(
    $input: SubmitWithdrawalWithCustomDateInput!
  ) {
    submitWithdrawalWithCustomDate(input: $input) {
      id
    }
  }
`;

export const CANCEL_WITHDRAWAL = gql`
  mutation CANCEL_WITHDRAWAL($input: CancelWithdrawalInput!) {
    cancelWithdrawal(input: $input) {
      id
      status
    }
  }
`;

export const DELETE_WITHDRAWAL = gql`
  mutation DELETE_WITHDRAWAL($input: DeleteWithdrawalInput!) {
    deleteWithdrawal(input: $input) {
      id
      status
    }
  }
`;

export const APPROVE_WITHDRAWAL = gql`
  mutation APPROVE_WITHDRAWAL($input: ApproveWithdrawalInput!) {
    approveWithdrawal(input: $input) {
      id
      status
    }
  }
`;

export const VOID_WITHDRAWAL = gql`
  mutation VOID_WITHDRAWAL($input: VoidWithdrawalInput!) {
    voidWithdrawal(input: $input) {
      id
      status
    }
  }
`;
